import { useEffect, useState } from "react";

export const useCountdown = (initialTime: number) => {
  const [remainingSeconds, setRemainingSeconds] = useState<number>(initialTime);
  const [isRunning, setIsRunning] = useState<boolean>(initialTime > 0);

  useEffect(() => {
    if (isRunning) {
      const intervalId = setInterval(() => {
        setRemainingSeconds((prev) => {
          const newValue = prev - 1;
          if (newValue <= 0) {
            setIsRunning(false);
            return 0;
          }
          return newValue;
        });
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [isRunning]);

  return remainingSeconds;
};
